/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer to chat? Join our Discord`)
};

const es_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Prefieres chatear? Únete a nuestro Discord`)
};

const de_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieber chatten? Tritt unserem Discord bei`)
};

const nl_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liever chatten? Word lid van onze Discord`)
};

const fr_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous préférez discuter ? Rejoignez notre Discord`)
};

const it_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferisci chattare? Unisciti al nostro Discord`)
};

const pt_br2_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefere conversar? Entre no nosso Discord`)
};

const pt_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preferes conversar? Junta-te ao nosso Discord`)
};

const ja_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャットがお好みですか？Discord に参加しましょう`)
};

const zh_contact_discord_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更喜欢聊天？加入我们的 Discord`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_discord_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_discord_heading(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_discord_heading", locale)
	if (locale === "en") return en_contact_discord_heading(inputs)
	if (locale === "es") return es_contact_discord_heading(inputs)
	if (locale === "de") return de_contact_discord_heading(inputs)
	if (locale === "nl") return nl_contact_discord_heading(inputs)
	if (locale === "fr") return fr_contact_discord_heading(inputs)
	if (locale === "it") return it_contact_discord_heading(inputs)
	if (locale === "pt-BR") return pt_br2_contact_discord_heading(inputs)
	if (locale === "pt") return pt_contact_discord_heading(inputs)
	if (locale === "ja") return ja_contact_discord_heading(inputs)
	return zh_contact_discord_heading(inputs)
};